import React, { useEffect, useState } from "react"
import { X } from "lucide-react"
import { appStore } from "lib/state"


export default function ElementEditorWrapper({ title, children }: { title:string; children:React.ReactNode }){

  const { store, AppStore }:any = appStore()
  const { update } = AppStore

  return (
    <div className="w-full h-full flex flex-col border border-solid border-slate-700 p-[2px]">
      <div className="w-full h-8 flex justify-between items-center bg-slate-700 px-5 font-bold text-neutral-300 uppercase tracking-wider">
        <span>{ title }</span>
        <X className="size-5 cursor-pointer stroke-1" onClick={() => update("element", { refstr: null, title: null })} />
      </div> 

      <div className="w-full p-4 relative">
        { children }
      </div>

    </div>
  )
}